import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logoImg from '../assets/logo.jpg';
import styles from './Header.module.css';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  // Close menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <Link className={styles.logo} to="/">
          <img src={logoImg} alt="Ragged Spade" className={styles.logoImg} />
          <span className={styles.logoText}>Ragged Spade</span>
        </Link>

        {/* Desktop Navigation */}
        <nav className={styles.nav}>
          <Link to="/#about" className={styles.navLink}>About</Link>
          <Link to="/#apps" className={styles.navLink}>Apps</Link>
          <Link to="/#contact" className={styles.navLink}>Contact</Link>
        </nav>

        {/* Hamburger Button */}
        <button
          className={`${styles.hamburger} ${isMenuOpen ? styles.open : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={isMenuOpen}
        >
          <span className={styles.hamburgerLine}></span>
          <span className={styles.hamburgerLine}></span>
          <span className={styles.hamburgerLine}></span>
        </button>
      </div>

      {/* Mobile Navigation */}
      <nav className={`${styles.mobileNav} ${isMenuOpen ? styles.open : ''}`}>
        <Link to="/" className={styles.mobileNavLink} onClick={handleNavClick}>
          Home
        </Link>
        <Link to="/#about" className={styles.mobileNavLink} onClick={handleNavClick}>
          About
        </Link>
        <Link to="/#apps" className={styles.mobileNavLink} onClick={handleNavClick}>
          Apps
        </Link>
        <Link to="/#contact" className={styles.mobileNavLink} onClick={handleNavClick}>
          Contact
        </Link>
      </nav>
    </header>
  );
}

export default Header;
